import ChangeLanguage from './ChangeLanguage'

export default ChangeLanguage
